<p class="intro" [innerHTML]="'parameters/alcmeon-ai/docs/intro' | translate"></p>

<app-search-bar
  [primaryButtonAction]="newDocument"
  [primaryButtonDisabled]="!isGaiaExists"
  [primaryButtonKey]="'parameters/alcmeon-ai/docs/button-new'"
  [searchKey]="'parameters/alcmeon-ai/docs/search-placeholder'"></app-search-bar>

<app-table [config]="config" [filters]="filters"></app-table>
